import { generateActionCreator as generate, reduxTypes as types } from 'ggtmo-utils';


export const INTEGRATIONS_GET_INTEGRATION = generate('INTEGRATIONS_GET_INTEGRATION', { type: types.ASYNC });
export const INTEGRATIONS_TWITTER_ENABLE = generate('INTEGRATIONS_TWITTER_ENABLE', { type: types.ASYNC });
// eslint-disable-next-line max-len
export const INTEGRATIONS_TWITTER_AUTHENTICATION_SUCCESS = generate('INTEGRATIONS_TWITTER_AUTHENTICATION_SUCCESS', { type: types.ASYNC });
